<template>
	<div class="admin-otp">
		<managing-section size="l">
			<managing-box title="QR Code">
				<img :src="qrImg" />
			</managing-box>
			<managing-box title="One-time Password">
				<span class="admin-otp__label admin-otp__label--blue">{{
					otp
				}}</span>
			</managing-box>
			<managing-box title="Updating in">
				{{ countDown }}
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button
				class="btn-main"
				type="button"
				@click="$store.commit('modal/toggleModal', {})"
			>
				닫기
			</button>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';

	export default {
		name: 'AdminOtp',
		components: { ManagingSection, ManagingBox },
		data() {
			return {
				qrImg: '',
				otp: '',
				timer: null,
				countDown: 0,
			};
		},
		computed: {
			...mapState({
				email: state => state.modal.params.email,
			}),
		},
		created() {
			this.getOtp();
		},
		beforeDestroy() {
			clearInterval(this.timer);
		},
		methods: {
			startCount(time) {
				this.countDown = 30 - (time % 30);
				this.timer = setInterval(() => {
					this.countDown--;
					if (this.countDown < 1) {
						clearInterval(this.timer);
						this.getOtp();
					}
				}, 1000);
			},
			async getOtp() {
				try {
					const params = {
						eMail: this.email,
					};
					const { data } = await this.$axiosAuth.get(
						'/public/admin.auth/otp',
						{ params }
					);
					this.startCount(data.time);
					this.qrImg = data.qrImg;
					this.otp = data.otp;
				} catch (err) {
					console.error(err);
					alert(
						'OTP 정보를 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
		},
	};
</script>

<style lang="scss">
	.admin-otp__label {
		background: #657088;
		padding: 4px 8px;
		border-radius: 12px;
		color: #fff;
		font-weight: bold;
	}

	.admin-otp__label--blue {
		background: $btn-blue;
	}
</style>
